export const experiences = [
  {
    id: 0,
    title: "EasyPay Customer App",
    company: "EasyPay",
    location: "Port Harcourt Nigeria",
    date: "Sept 2023 – Present",
    tasks: [
      "Worked on a fintech mobile application using flutter dart",
      "Implemented payment services to easily pay for bills and utilities",
      "Created card system for easy payments",
    ],
  },
  {
    id: 1,
    title: "EasyPay Agent App",
    company: "EasyPay",
    location: "Port Harcourt Nigeria",
    date: "Sept 2023 – Present",
    tasks: [
      "Created an agent mobile app for agents to use",
      "Agents can pay bills for others and receive commission",
      "Fixed and maintaining the app",
    ],
  },
  {
    id: 2,
    title: "Mobile App Developer",
    company: "CastleVault",
    location: "Abuja Nigeria",
    date: "Sept 2023 – Present",
    tasks: [
      "Created a fully functional fintech mobile app using flutter",
      "Implemented crypto and backend services",
      "Incorporated different thirdparty services to bring the app to live",
    ],
  },
  {
    id: 3,
    title: "Mobile App Developer",
    company: "VelcroPay",
    location: "Port Harcourt Nigeria",
    date: "Aug 2023 – Present",
    tasks: [
      "Created a fintech mobile application from scratch using flutter dart",
      "Implemented backend service using firebase according to clients preferences",
      "Incorporated thirdparty service eg Gift Card, SME. into the app",
    ],
  },
  {
    id: 4,
    title: "Frontend Developer",
    company: "Candleweb",
    location: "Abuja Nigeria",
    date: "Feb 2023 – Aug 2023",
    tasks: [
      "Created a web3 crypto website from scratch.",
      "Worked with a backend developer and UI/UX designer to build the app.",
      "Add a web3 smart contract functionality to make crypto payment.",
    ],
  },
  {
    id: 5,
    title: "Mobile App Developer",
    company: "Kreebz",
    location: "Ikega Lagos",
    date: "Oct 2022 – Jan 2023",
    tasks: [
      "Created a fully functional real estate mobile application.",
      "Implemented payment wallet into it.",
      "Collabed and communicated with the backend developer to connect the app to the database using Api.",
    ],
  },
  {
    id: 6,
    title: "Mobile App Developer",
    company: "FoodNow",
    location: "Ikega Lagos",
    date: "Nov 2021 – Mar 2022",
    tasks: [
      "Identify, analyzed and debugged app issues with both back-end and front-end developers on the team.",
      "Recreated, Designed & maintained the app.",
      "Added a payment wallet, social system & Organizations",
    ],
  },
  {
    id: 7,
    title: "Full Stack Developer",
    company: "Quelib",
    location: "Port Harcourt",
    date: "Jun 2021 – Present",
    tasks: [
      "Created and implemented a full working mobile application from scratch to production with both back-end and front-end ",
      "Marketed and Advertised the app via Facebook and Twitter and getting over 200% increase in users ",
      "Push app to Google play store",
    ],
  },
  // {
  //   id: 6,
  //   title: "Full Stack Developer",
  //   company: "Ohms",
  //   location: "Port Harcourt",
  //   date: "Nov 2020 – May 2021",
  //   tasks: [
  //     "Created the wireframe and designed the app using flutter framework ",
  //     "Developed the backend using php mysql and connected to the frontend using restful api",
  //   ],
  // },
  // {
  //   id: 7,
  //   title: "Full Stack Developer",
  //   company: "Albaama",
  //   location: "Port Harcourt",
  //   date: "Oct 2019 – Nov 2020",
  //   tasks: [
  //     "Used HTML CSS to create an e-commerce website with stunning UI and great User experience",
  //     "Completely created am admin section with full functional using php mysql",
  //   ],
  // },
];
